/**
 * Animation variants for marketing pages
 * Using Framer Motion for smooth, professional animations
 */

/**
 * Fade in from below with smooth transition
 * Used for individual elements that appear as user scrolls
 */
export const fadeInUp = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5 }
  }
};

/**
 * Container animation that staggers children
 * Used to create cascading animations for groups of elements
 */
export const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
